// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body,
html {
  overflow-x: hidden;
}

.bar {
  width: 100%;

  /* padding: 5px 0 0 0; */

  background-color: rgb(234 88 12);
  color: white;

  font-family: Gelasio;
  font-size: 28px;
}

.bar_content {
  display: block; /*Important to give the content a width*/

  width: 150%;
  transform: translateX(100%); /* Animation start out of the screen */

  /* Add the animation */
  animation: move 30s linear infinite
    /* infinite make reapeat the animation indefinitely */;
}

/* Create the animation */
@keyframes move {
  to {
    transform: translateX(-100%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;;EAEX,wBAAwB;;EAExB,gCAAgC;EAChC,YAAY;;EAEZ,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc,EAAE,wCAAwC;;EAExD,WAAW;EACX,2BAA2B,EAAE,sCAAsC;;EAEnE,sBAAsB;EACtB;0DACwD;AAC1D;;AAEA,yBAAyB;AACzB;EACE;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nbody,\nhtml {\n  overflow-x: hidden;\n}\n\n.bar {\n  width: 100%;\n\n  /* padding: 5px 0 0 0; */\n\n  background-color: rgb(234 88 12);\n  color: white;\n\n  font-family: Gelasio;\n  font-size: 28px;\n}\n\n.bar_content {\n  display: block; /*Important to give the content a width*/\n\n  width: 150%;\n  transform: translateX(100%); /* Animation start out of the screen */\n\n  /* Add the animation */\n  animation: move 30s linear infinite\n    /* infinite make reapeat the animation indefinitely */;\n}\n\n/* Create the animation */\n@keyframes move {\n  to {\n    transform: translateX(-100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
